import React from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';

function Blog() {
    const navigate = useNavigate();
     const eventData = useSelector((state) => state.event.eventData);
      const artical = eventData.articles|| [];
      const articles = eventData.articles.awards|| [];
      const data1 = articles[0];
      const data2 = articles[1];
      const data3 = articles[2];
  return (
    <section class="bg-smoke overflow-hidden space">
    <div class="container">
        <div class="row justify-content-lg-between justify-content-center align-items-end">
            <div class="col-lg">
                <div class="title-area text-center text-lg-start">
                    <span class="sub-title"> {artical.title}</span>
                    <h2 class="sec-title">{artical.subTitle}</h2>

                </div>
            </div>
            <div class="col-lg-auto d-none d-lg-block">
                <div class="sec-btn">
                    <a onClick={() => navigate('/artical/details', { state: { item: articles } })} class="th-btn style4 th-icon">See More Articles</a>
                </div>
            </div>
        </div>
        <div class="row gx-24 gy-30">
            <div class="col-xl-5">
                <div class="blog-grid th-ani">
                    <div class="blog-img global-img">
                        <img src={articles[0].imageKey} alt="blog_image"/>
                    </div>
                    <div class="blog-grid_content">
                        <div class="blog-meta">
                            <a class="author" href="/artical/details">{articles[0].date}</a>
                        </div>
                        <h3 class="box-title"><a href="/artical/details">{articles[0].name}</a></h3>
                        <a onClick={() => navigate('/artical/details', { state: { item: data1 } })} class="th-btn style4 th-icon">Read More</a>
                    </div>
                </div>
            </div>
            <div class="col-xl-7">
                <div class="blog-grid style2 th-ani">
                    <div class="blog-img global-img">
                        <img src={articles[1].imageKey} alt="blog_image"/>
                    </div>
                    <div class="blog-grid_content">
                        <div class="blog-meta">
                            <a class="author" href="/artical/details">{articles[1].date}</a>
                        </div>
                        <h3 class="box-title"><a href="/artical/details">{articles[1].name}</a></h3>
                        <a onClick={() => navigate('/artical/details', { state: { item: data2 } })} class="th-btn style4 th-icon">Read More</a>
                    </div>
                </div>
                <div class="blog-grid th-ani style2 mt-24">
                    <div class="blog-img global-img">
                        <img src={articles[2].imageKey} alt="blog_image"/>
                    </div>
                    <div class="blog-grid_content">
                        <div class="blog-meta">
                            <a class="author" href="/artical/details">{articles[2].date}</a>
                        </div>
                        <h3 class="box-title"><a href="/artical/details">{articles[2].name}</a></h3>
                        <a onClick={() => navigate('/artical/details', { state: { item: data3 } })} class="th-btn style4 th-icon">Read More</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="shape-mockup shape1 d-none d-xxl-block" data-top="14%" data-right="-13%">
            <img src="assets/img/shape/shape_1.png" alt="shape"/>
        </div>
        <div class="shape-mockup shape2 d-none d-xl-block" data-top="25%" data-right="-12%">
            <img src="assets/img/shape/shape_2.png" alt="shape"/>
        </div>
        <div class="shape-mockup shape3 d-none d-xxl-block" data-top="20%" data-right="-18%">
            <img src="assets/img/shape/shape_3.png" alt="shape"/>
        </div>
        <div class="shape-mockup movingX d-none d-xxl-block" data-bottom="-15%" data-right="10%">
            <img src="assets/img/shape/shape_9.png" alt="shape"/>
        </div>
    </div>


</section>
  )
}

export default Blog